module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2018 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published 2018")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("27 26 25 24 23 22 21 20 19 18    1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("ISBN-13: 978-0-226-02380-9 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-02394-6 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("DOI: "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://doi.org/10.7208/chicago/9780226023946.001.0001",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.7208/chicago/9780226023946.001.0001")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Originally published as "), _c('i', [_vm._v("L’effectif et le rationnel. Hegel et l’esprit objectif")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© Librairie Philosophique J. Vrin, Paris, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.vrin.fr",
      "target": "_blank"
    }
  }, [_vm._v("http://www.vrin.fr")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Cet ouvrage a bénéficié du soutien des programmes d’aide à la publication de l’Institut français. This work, published as part of a program of aid for publication, received support from the Institut français. Published with the cooperation of the Université Paris I Panthéon-Sorbonne and of the University Institute of France.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "139",
      "src": "images/logo-CNL-new-red.jpg",
      "width": "295"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.centrenationaldulivre.fr",
      "target": "_blank"
    }
  }, [_vm._v("www.centrenationaldulivre.fr")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloguing-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Names: Kervégan, Jean-François, author. | Ginsburg, Daniela, translator. | Shuster, Martin, translator.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: The actual and the rational : Hegel and objective spirit / Jean-François Kervégan ; translated by Daniela Ginsburg and Martin Shuster.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Other titles: Effectif et le rationnel. English")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Chicago ; London : The University of Chicago Press, 2018. | Includes bibliographical references and index. | Originally published: Paris : Librairie philosphique J. Vrin. © 2008 under title L’effectif et le rationnel: Hegel et l’esprit objectif.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: LCCN 2017059969 | ISBN 9780226023809 (cloth : alk. paper) | ISBN 9780226023946 (pbk.)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: LCSH: Hegel, Georg Wilhelm Friedrich, 1770–1831. | Law—Philosophy. | Political science—Philosophy. | Objectivity. | Subjectivity.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: LCC K230.H432 K4713 2018 B2948 | DDC 193—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2017059969",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2017059969")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "12",
      "src": "images/infinity-symbol.jpg",
      "width": "12"
    }
  }), _vm._v(" This paper meets the requirements of ANSI"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("/")]), _vm._v("NISO Z39.48-1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d060b98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-kervegan-0004.vue
// module id = 63
// module chunks = 0